import type { RouterConfig } from "nuxt/schema";

export default <RouterConfig>{
  // https://router.vuejs.org/api/interfaces/routeroptions.html#routes
  routes(_routes) {
    return [
      ..._routes,

      /**
       * Authentication variants all use same component
       */
      { path: "/auth", redirect: "/login" },
      {
        path: "/login",
        component: () => import("~/pages/auth.vue").then((r) => r.default || r),
        props: { login: true },
      },
      {
        path: "/register",
        component: () => import("~/pages/auth.vue").then((r) => r.default || r),
        props: { register: true },
      },
      {
        path: "/forgot",
        component: () => import("~/pages/auth.vue").then((r) => r.default || r),
        props: { forgot: true },
      },
      {
        path: "/reset",
        component: () => import("~/pages/auth.vue").then((r) => r.default || r),
        props: { reset: true },
      },

      /**
       * Case viewer routes
       */
      {
        path: "/viewer/case/:caseDefShortid",
        component: () =>
          import("~/pages/case-viewer.vue").then((r) => r.default || r),
        props: true,
      },
      {
        path: "/viewer/case/edit/:caseDefShortid",
        component: () =>
          import("~/pages/case-editor.vue").then((r) => r.default || r),
        props: true,
      },
      {
        path: "/viewer/playlist/:playlistId/review",
        component: () =>
          import("~/pages/case-viewer.vue").then((r) => r.default || r),
        props: true,
      },
      {
        path: "/toolbar",
        component: import("~/pages/viewer-controls-demo.vue").then(
          (r) => r.default || r
        ),
      },
    ];
  },
};
